module.exports = __webpack_public_path__ + "img/5.09a394dc.png";